module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 11.3c508989.wav";